export const GET_ACTIVE_PARTICIPANTS_API_HTTP_STATUS_CODES = [
  403, 404, 422, 500, 503, 504,
];

export const GET_ACTIVE_PARTICIPANTS_ERROR_MESSAGE =
  "Error in getting active participants";
